import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { v2ErrorMessage } from '../../shared/utils/v2-api-response.util';
import { buildSearchPayload } from '../../shared/utils/table-state.utils';
import { SearchPayload, TableStateSnapshot } from '../../shared/utils/table-types';

export interface InvestmentListResult<T, S> {
  items: T[];
  total: number;
  summary: S | null;
}

export function investmentListPayload(state: TableStateSnapshot): SearchPayload {
  const payload = buildSearchPayload({ ...state, pageIndex: state.pageIndex || 0, pageSize: state.pageSize || 10 });
  payload.search = String((state.filters && state.filters.search) || '').trim();
  return payload;
}

export function requestInvestmentList<T, S>(http: HttpClient, endpoint: string, payload: SearchPayload, errorText: string): Promise<InvestmentListResult<T, S>> {
  return firstValueFrom(http.post<any>(environment.apiUrl + endpoint, payload))
    .catch(error => {
      throw { status: error && error.status, error: { message: v2ErrorMessage(error && error.error, errorText) } };
    })
    .then(response => {
      if (!response || response.isSuccess === false) {
        throw { error: { message: v2ErrorMessage(response, errorText) } };
      }
      const items: T[] = Array.isArray(response.values) ? response.values : [];
      return {
        items,
        total: Number(response.total) || 0,
        summary: response.summary || null,
      };
    });
}

export function investmentSearchFromState(state: TableStateSnapshot | null): string {
  return String((state && state.filters && state.filters.search) || '');
}
